import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

import Currency from 'components/Currency';
import Stat from 'components/Stat';

const StyledActionBar = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  position: relative;
  background: ${theme.B400};
  padding: 15px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
  z-index: 2;

  .ActionBar__left {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: repeat(auto-fit, minmax(100px, auto));
    justify-content: start;
  }

  .ActionBar__right {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: repeat(auto-fit, minmax(150px, auto));
    justify-content: end;
  }

  select {
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);

    .ActionBar__left,
    .ActionBar__right {
      justify-content: normal;
    }
  }
`;

const ActionBar = ({ children, ...props }) => {
  const { startingBalance, totalBalance, totalPaid, currentProgress } = props;
  return (
    <StyledActionBar>
      <div className="ActionBar__left">
        <Stat title="Starting Balance">
          <Currency quantity={startingBalance} pattern="!##,### " />
        </Stat>
        <Stat title="Remaining Balance">
          <Currency quantity={totalBalance} pattern="!##,### " />
        </Stat>
        <Stat title="Total Paid">
          <Currency quantity={totalPaid} pattern="!##,### " />
        </Stat>
        <Stat title="Progress">{`${currentProgress}%`}</Stat>
      </div>
      <div className="ActionBar__right">{children(props)}</div>
    </StyledActionBar>
  );
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/components/ActionBar/ActionBar.js